
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Star } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import CommentUserHoverCard from './CommentUserHoverCard';

interface CommentHeaderProps {
  avatar: string;
  name: string;
  isJournalist?: boolean;
  highlighted?: boolean;
  timestamp: string;
  bio?: string;
  joinDate?: string;
}

const CommentHeader: React.FC<CommentHeaderProps> = ({
  avatar,
  name,
  isJournalist,
  highlighted,
  timestamp,
  bio,
  joinDate
}) => {
  return (
    <div className="flex justify-between mb-1">
      <div className="flex items-center">
        <CommentUserHoverCard
          avatar={avatar}
          name={name}
          isJournalist={isJournalist}
          bio={bio}
          joinDate={joinDate}
        >
          <span className="font-medium">{name}</span>
        </CommentUserHoverCard>
        
        {isJournalist && (
          <Badge variant="outline" className="ml-2 bg-primary/10 text-primary text-xs">
            Journalist
          </Badge>
        )}
        
        {highlighted && (
          <div className="ml-2">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Star className="h-4 w-4 text-amber-500 fill-amber-500" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Featured comment</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        )}
      </div>
      <span className="text-xs text-muted-foreground">{timestamp}</span>
    </div>
  );
};

export default CommentHeader;
